import keyboardEventKeyPolyfill from 'keyboardevent-key-polyfill'
import 'event-propagation-path'

keyboardEventKeyPolyfill.polyfill()
